import { jsx as _jsx } from "react/jsx-runtime";
export const IframePage = (props) => {
    return _jsx("iframe", { src: props?.src, width: '100%', height: '100%', title: props?.title, scrolling: "yes", frameBorder: 0 });
};
